import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";

if (!process.env.REACT_APP_NETWORK || !process.env.REACT_APP_CONTRACT_ADDRESS)
  throw new Error("Not all environment variables are defined");

console.log(process.env.REACT_APP_NETWORK);
console.log(process.env.REACT_APP_CONTRACT_ADDRESS);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
